/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import { Context } from "../AppContext";
import { ContextUI } from '../uiContext';
import GeneralService from '../services/general';
import { Button } from '../components/ui/button';
import { Paper } from '../components/ui/paper';
import ServiceGeneral from '../services/general';
import { SearchBar } from '../components/ui/searchBar';
import { KeyBoardArrowDown, KeyBoardArrowUp } from '../components/ui/coreIcons';


const Revisions = (props) => {
    const contextUI = useContext(ContextUI);
    const context = useContext(Context);
    const [revisions, setRevisions] = useState([]);
    const [search, setSearch] = useState('');
    const [sortAttribute, setSortAttribute] = useState('date');
    const [sortOrder, setSortOrder] = useState('321');

    useEffect(() => {
        contextUI.setTitle('Revisies');
        contextUI.setSubTitle('');
        contextUI.setShowBackButton(false);

        let tmpList = [];
        {
            context.info.Revisions.map((revision, index) => {
                if (revision.Revision && revision.Revision.changes && revision.Revision.changes.length > 0) {
                    for (let i = 0; i < revision.Revision.changes.length; i++) {
                        let change = revision.Revision.changes[i];
                        let tempItem = {};
                        if (change.date && change.remark) {
                            let tempItem = {};
                            tempItem.HPath = revision.HPath;
                            tempItem.path = revision.Path;
                            tempItem.name = revision.Revision.name || '';
                            tempItem.date = change.date;
                            tempItem.author = change.author || '';
                            tempItem.version = parseFloat(change.version) || 0;
                            tempItem.remark = change.remark || '';
                            tempItem.uuid = change.uuid;
                            tempItem._id = change.uuid;
                            tmpList.push(tempItem);
                        }
                    }
                }
            })
        }
        setRevisions(tmpList);
    }, [])

    const isLatest = (revision) => {
        let latest = true;
        for (let i = 0; i < revisions.length; i++) {
            if (revisions[i].date > revision.date && revisions[i].path === revision.path) {
                latest = false;
                break;
            }
        }
        return latest;
    }

    const handleSearch = (search) => {
        setSearch(search);
    }

    const getSortIcon = (attribute) => {
        if (sortAttribute === attribute) {
            if (sortOrder === '321') {
                return <div style={{float:'right'}}><KeyBoardArrowDown/></div>
            } else {
                return <div style={{float:'right'}}><KeyBoardArrowUp/></div>;
            }
        }
        return '';
    }

    if (!context.info && context.info.Revisions) return null;
    return (
        <div className="padding">
            <SearchBar onKeyUp={handleSearch} onReset={() => { setSearch('') }} />
            <Paper>
                <table className='w3-table'>
                    <tbody>
                        <tr>
                            <th  style={{cursor:'pointer'}} onClick={()=>{setSortAttribute('path');if(sortOrder=='123'){setSortOrder('321')}else{setSortOrder('123')}}}>Locatie {getSortIcon('path')} </th>
                            <th  style={{cursor:'pointer'}} onClick={()=>{setSortAttribute('date');if(sortOrder=='123'){setSortOrder('321')}else{setSortOrder('123')}}}>Datum {getSortIcon('date')} </th>
                            <th style={{cursor:'pointer'}}  onClick={()=>{setSortAttribute('author');if(sortOrder=='123'){setSortOrder('321')}else{setSortOrder('123')}}}>Gewijzigd door {getSortIcon('author')} </th>
                            <th style={{cursor:'pointer'}}  onClick={()=>{setSortAttribute('version');if(sortOrder=='123'){setSortOrder('321')}else{setSortOrder('123')}}}>Versie {getSortIcon('version')} </th>
                            <th style={{cursor:'pointer'}}  onClick={()=>{setSortAttribute('remark');if(sortOrder=='123'){setSortOrder('321')}else{setSortOrder('123')}}}>Opmerking {getSortIcon('remark')} </th>
                        </tr>
                        {GeneralService.sortJSON(revisions,sortAttribute,sortOrder).map((revision, index) => {
                            if (!revision.date) return null;
                            if (!isLatest(revision)) return null;
                            if(search && search.length > 0) {
                                if (JSON.stringify(revision).toLowerCase().indexOf(search.toLowerCase()) === -1) {
                                    return null;
                                }
                            }
                            return (
                                <tr key={index}>
                                    <td>/{revision.path.replace('Zakboekje/','')}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>{GeneralService.formatDate(revision.date, false)}</td>
                                    <td  >{revision.author}</td>
                                    <td>{revision.version}</td>
                                    <td>{revision.remark}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </Paper>
        </div>
    )
}
export default Revisions;
